// Custom fields
type CustomFieldTypes = `string` | `number` | `multiselect` | `select` | `boolean`;

// Stop fields ===============================================================
export const projectPlannerStopFieldsID = [
  `external_id`,
  `location_details`,
  `comments`,
  `reference_person`,
  `email`,
  `phone`,
  `url`,
];

export type ProjectPlannerStopSpecificFieldsType =
  | `external_id`
  | `location_details`
  | `comments`
  | `reference_person`
  | `email`
  | `phone`
  | `url`;

export type ProjectPlannerStopFieldsType = `string` | `number` | `email` | `phone` | CustomFieldTypes;

export const projectPlannerStopFieldsValues = {
  external_id: `string`,
  location_details: `string`,
  comments: `string`,
  reference_person: `string`,
  email: `email`,
  phone: `phone`,
  url: `string`,
} as Record<ProjectPlannerStopSpecificFieldsType, ProjectPlannerStopFieldsType>;

// Vehicle fields ===============================================================
export const projectPlannerVehicleFieldsID = [
  `external_id`,
  `comments`,
  `plate`,
  `phone`,
  `email`,
  `price_per_minute`,
  `price_per_distance`,
];

export type ProjectPlannerVehicleSpecificFieldsType =
  | `external_id`
  | `comments`
  | `plate`
  | `phone`
  | `email`
  | `price_per_minute`
  | `price_per_distance`;

export type ProjectPlannerVehicleFieldsType = `string` | `number` | `email` | `phone` | CustomFieldTypes;

export const projectPlannerVehicleFieldsValues = {
  external_id: `string`,
  comments: `string`,
  plate: `string`,
  phone: `phone`,
  email: `email`,
  price_per_minute: `number`,
  price_per_distance: `number`,
} as Record<ProjectPlannerVehicleSpecificFieldsType, ProjectPlannerVehicleFieldsType>;

// Task fields ===============================================================
export const projectDriversTaskFieldsValues = [`barcode`, `comments`];

export type ProjectPlannerTaskSpecificFieldsType = (typeof projectDriversTaskFieldsValues)[number];

export type ProjectPlannerTaskFieldsType = `string` | `barcode` | CustomFieldTypes;

export const projectPlannerTaskFieldsValues = {
  barcode: `barcode`,
  comments: `string`,
} as Record<ProjectPlannerTaskSpecificFieldsType, ProjectPlannerTaskFieldsType>;
